<template>
  <v-container>
    <v-dialog
      persistent
      overlay-opacity="0.5"
      v-model="leaveSheetDialog.open"
      width="80%"
    >
      <v-card tile>
        <v-btn
          icon
          :style="{
            float: 'right',
            color: '#000',
            marginTop: '1%',
          }"
          style="position: absolute; right: 1em"
          @click="leaveSheetDialog = false"
        >
          <v-icon size="30">mdi-close</v-icon>
        </v-btn>
        <v-card-title> Leave Sheet </v-card-title>
        <v-card-text class="pa-0">
          <!-- PDF Viewer Iframe (Desktop) / Mobile Placeholder -->
          <div
            class="pa-0 elevation-1"
            :style="{
              height: isMobile ? 'auto' : '80vh',
              minHeight: isMobile ? '300px' : '700px',
              position: 'relative',
              background: isMobile ? '#ffffff' : '#525659'
            }"
          >
            <!-- Loader while Blob URL is being created/loaded -->
            <div v-if="!pdfUrl" class="pa-4 white" style="height: 100%">
              <v-skeleton-loader type="image" height="100%" />
            </div>

            <template v-else>
              <!-- Mobile Optimized View -->
              <div
                v-if="isMobile"
                class="pa-12 text-center d-flex flex-column align-center justify-center"
              >
                <v-icon size="100" color="primary lighten-4"
                  >mdi-file-pdf-box</v-icon
                >
                <div
                  class="mt-6 grey--text text--darken-2 headline font-weight-bold"
                >
                  Leave Sheet Preview
                </div>
                <div class="mt-2 grey--text subtitle-1 mb-8">
                  Your leave sheet is ready. Since you are on a mobile device,
                  please use the button below to view it.
                </div>
                <v-btn
                  x-large
                  color="primary"
                  class="text-none px-8 rounded-lg shadow-lg"
                  @click="openPdfInNewTab"
                >
                  <v-icon left>mdi-eye</v-icon>
                  Open Leave Sheet
                </v-btn>
                <div class="mt-4 grey--text caption">
                  The document will open in your device's native PDF viewer.
                </div>
              </div>

              <!-- Desktop Iframe View -->
              <iframe
                v-else
                ref="leaveSheet"
                :src="pdfUrl"
                width="100%"
                height="100%"
                frameborder="0"
                style="border: none; display: block"
                title="Leave Sheet Viewer"
                loading="lazy"
              ></iframe>
            </template>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "LeaveSheet",
  data: () => ({
    pdfUrl: null,
  }),
  computed: {
    ...mapState({}),
    leaveSheetDialog: {
      get() {
        return this.$store.state.leave.leaveSheetDialog;
      },
      set(value) {
        this.$store.commit("leave/SET_LEAVE_SHEET", {
          open: value,
          leaveSheet: "",
        });
      },
    },
    isMobile() {
      // Production-grade mobile detection
      return (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        ) || window.innerWidth <= 768
      );
    },
  },
  watch: {
    "leaveSheetDialog.leaveSheet": {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.generatePdfUrl(newValue);
        } else {
          if (this.pdfUrl) {
            URL.revokeObjectURL(this.pdfUrl);
            this.pdfUrl = null;
          }
        }
      },
    },
  },
  methods: {
    ...mapActions({}),
    generatePdfUrl(base64Data) {
      if (this.pdfUrl) {
        URL.revokeObjectURL(this.pdfUrl);
      }
      try {
        const binaryString = window.atob(base64Data);
        const len = binaryString.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
          bytes[i] = binaryString.charCodeAt(i);
        }
        const blob = new Blob([bytes], { type: "application/pdf" });
        this.pdfUrl = URL.createObjectURL(blob);
      } catch (e) {
        console.error("Error generating PDF URL", e);
      }
    },
    openPdfInNewTab() {
      if (!this.pdfUrl) return;
      window.open(this.pdfUrl, "_blank");
    },
    PrintElem() {
      if (this.$refs.leaveSheet) {
        this.$refs.leaveSheet.contentWindow.print();
      }
    },
  },
  beforeDestroy() {
    if (this.pdfUrl) {
      URL.revokeObjectURL(this.pdfUrl);
    }
  },
};
</script>
<style scoped>
.shadow-lg {
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(0, 0, 0, 0.05) !important;
}
</style>
